import { atom } from 'recoil';

export const BusinessHoursState = atom({
    key: 'BusinessHoursState', 
    default: null, 
});